import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Filter, Main } from 'Containers/';
import { TitledCard } from 'Components/';
import {
  fetchData,
  saveCloseVerification,
} from './state/verificationclose/actions';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';
import _ from 'lodash';
import TopMessage from './components/TopMessage';
import { LoadingPage } from 'Components';
import moment from 'moment';
import { AreYouSureDialog } from './components/AreYouSureDialog';

class VerificationCloseContainer extends Component {
  state = {
    areYouSureDialog: {
      shown: false,
    },
  };

  formSubmit = () => {
    return this.props.saveCloseVerification;
  };

  componentDidMount() {
    this.props.fetchData();
  }

  componentDidUpdate(prevProps) {
    errorToast(this.props, prevProps, 'fetchError');

    if (!prevProps.submitted && this.props.submitted) {
      createToast(
        toastType.success,
        'Success',
        'Verification Closed successfully',
        true
      );
    }
  }

  disableForm = data => {
    if (
      !_.isEmpty(data) &&
      (!data.HasPrintedResults ||
        !data.HasStudentCountsRun ||
        moment().diff(data.AsOfDate_Student, 'hours') < 0 ||
        data.IsComplete)
    ) {
      return true;
    }

    return false;
  };

  onCloseMenuClick = () => {
    this.setState({
      areYouSureDialog: {
        shown: true,
      },
    });
  };

  onAreYouSureConfirm = () => {
    this.props.saveCloseVerification();
    this.onAreYouSureCancel();
  };

  onAreYouSureCancel = () => {
    this.setState({
      areYouSureDialog: {
        shown: false,
      },
    });
  };

  getMainProps = () => {
    const { data } = this.props;
    const disabled = this.disableForm(data);

    return {
      toolbox: {
        formName: ' ',
        saveButtonProps: {
          content: 'Close Verification',
          onClick: this.onCloseMenuClick,
          loading: this.props.fetching || this.props.submitting,
          disabled,
        },
        shown: true,
      },
    };
  };

  render() {
    return (
      <Fragment>
        {(this.props.fetching || this.props.submitting) && <LoadingPage />}
        <AreYouSureDialog
          {...this.state.areYouSureDialog}
          onConfirm={this.onAreYouSureConfirm}
          onCancel={this.onAreYouSureCancel}
        />
        <Filter title={'Close Verification'} />
        <Main {...this.getMainProps()}>
          <TopMessage data={this.props.data} />
          <TitledCard>
            This will end the verification process for the current year; then
            you can run the SFA Verification Reports. <br /> <br /> Verification
            Results cannot be changed after Verification is closed.
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { verificationclose } = state.VerificationCloseState;

  return {
    fetchError: verificationclose.fetchError,
    fetching: verificationclose.fetching,
    submitting: verificationclose.submitting,
    submitted: verificationclose.submitted,
    data: verificationclose.data,
  };
};

export const VerificationClose = withRouter(
  connect(
    mapStateToProps,
    { fetchData, saveCloseVerification }
  )(VerificationCloseContainer)
);



// WEBPACK FOOTER //
// ./src/pages/verificationclose/VerificationClose.js